/*eslint-env jquery*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../../Shared/MySweetAlert'
import Loading from '../../Shared/Loading'
import DatePicker from '../../Shared/DatePicker'
import UnitTaskStatusSelectBtns from '../../Shared/UnitTaskStatusSelectBtns'
import { DecimalInput } from 'react-hichestan-numberinput'
import TaskCode from '../../Shared/TaskCode'
// import Select from 'react-select'
import { unitTasksService } from '../../../_services/unitTasks.service'
// import { FaPlus } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { FiTrash2 } from 'react-icons/fi'
import { GiMagnifyingGlass } from 'react-icons/gi'
import { MdPlaylistAddCheck, MdAdd, MdBlock } from 'react-icons/md'
import { Field, FastField, ErrorMessage, getIn, Formik } from 'formik'
import unitTaskStatuses from '../../../_constants/unitTaskStatuses'
// import config from '../../../config'
// import NumberFormat from 'react-number-format'
// import ImportExcel from './ImportExcel'
// import measurementTypes from '../../../_constants/measurementTypes'
import taskOperationTypes from '../../../_constants/taskOperationTypes'
import { FaInfoCircle } from 'react-icons/fa'
import Form from './Form'
import { Tabs, Tab } from 'react-bootstrap'
import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'
//
import { Input } from 'antd'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'
// import AsyncCategorySelect from '../../Shared/AsyncCategorySelect'
// import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'

import moment from 'moment-jalaali'

import TaskReportModal from '../TaskReportModal'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const requestData = (pageSize, page, sorted, filtered, dto) => {
  // // console.log(dto)
  return new Promise(async (resolve, reject) => {
    // var dto = {};
    dto['pageSize'] = pageSize
    dto['page'] = page
    if (sorted && sorted.length > 0) {
      dto['sorted'] = sorted[0]
    }

    console.log(JSON.stringify(dto))

    var result = []
    await unitTasksService
      .getAllReservedSm(JSON.stringify(dto))
      .then(res => {
        // // console.log(res)
        result = res.data
      })
      .catch(err => {
        // setTimeout(() => requestData(pageSize, page, sorted, filtered, dto), 5000);
        // // console.log(err);
      })

    setTimeout(() => resolve(result), 100)
  })
}

class ReserveTasks extends Component {
  constructor(props, context) {
    super(props, context)

    var pageSize = parseInt(localStorage.getItem('pageSize'), 0)
    this.state = {
      initialItems: [],
      data: [],
      loading: false,
      confirmDeleteShow: false,
      requiredItem: 0,
      deleteItemIndex: 0,
      model: {},
      resetUpload: false,

      searchModal: false,
      pageSize: pageSize ? pageSize : 10,
      dto: {
        page: 0,
        pageSize: pageSize,
        unitTaskStatus: -1,
        sorted: { id: 'updatedAt', desc: true }
      },
      totalRecords: 0,

      reportModalShow: false,
      taskId: undefined,

      newReserve: false
    }
  }

  fetchData = (state, instance) => {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true })
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered,
      this.state.dto
    )
      .then(res => {
        console.log(res.data)

        if (res.data) {
          // var pageSize = res.data.result.length > state.pageSize ? state.pageSize : res.data.result.length;
          // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
          this.setState({
            data: res.data,
            // pages: res.totalPage,
            pages: Math.ceil(res.totalRecords / state.pageSize),
            totalRecords: res.totalRecords,
            loading: false,
            modal: false,
            searchModal: false,
            pageSize: state.pageSize
          })
        }
      })
      .catch(err => {
        // console.log(err);

        this.setState({ loading: false, searchModal: false })
      })
  }

  _handleSearch = e => {
    let searcjQery = e.target.value.toLowerCase(),
      displayedItems = this.state.initialItems.filter(el => {
        let searchValue = el.name.toLowerCase()
        return searchValue.indexOf(searcjQery) !== -1
      })
    this.setState({
      data: displayedItems
    })
  }

  _handleCancelSearch = e => {
    document.getElementById('searchInput').value = ''
    this.setState({
      data: this.state.initialItems
    })
  }

  handleFilterChange = () => {
    const current = this.reactTable.getResolvedState()

    if (current) {
      const recordsCount = current.sortedData.length
      this.setState({ recordsCount })
      // return false
      // console.log(recordsCount);
    }
  }

  handleSearch = values => {
    // console.log(values);

    this.setState({ loading: true })

    if (values) {
      // // Object.keys(values).length > 0 &&
      //   Object.entries(values)
      //     .reduce((acc, [key, value]) => {
      //       dto[key] = value
      //     })
      this.setState({ dto: values, page: 0 }, () => {
        // console.log(dto);
        this.table.fireFetchData()
      })
    }
  }

  handleShowAll = () => {
    var dto = {
      page: 0,
      pageSize: this.state.dto.pageSize,
      unitTaskStatus: undefined,
      sorted: { id: 'createdAt', desc: true }
    }
    this.setState({ dto: dto }, () => {
      this.table.fireFetchData()
    })
  }

  // componentDidMount() {

  //   this.table.fireFetchData();

  // }

  handleModalCreate = taskType => {
    this.setState(
      {
        taskType: taskType,
        modalHeading: 'ثبت کالای جدید',
        model: { name: '', measurementType: '', image: '' }
      },
      () => {
        this.setState({ modal: true })
      }
    )
  }

  handleModalReserve = taskType => {
    this.setState(
      {
        taskType: taskType,
        modalHeading: 'ثبت کالای جدید',
        model: { name: '', measurementType: '', image: '' },
        newReserve: true
      },
      () => {
        this.setState({ modal: true })
      }
    )
  }

  handleModalEdit = _model => {
    this.setState({ modal: true, model: _model })
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false, model: {} })
  }

  handleModalClose = () => {
    this.setState({ modal: false, model: {} }, () => {
      this.table.fireFetchData()
    })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  // getData() {
  //   this.setState({ loading: true });
  //   unitTasksService.getAllByCategoryType(this.props.categoryType)
  //     .then((res) => {
  //       console.log(res.data)
  //       this.setState({ initialItems: res.data, data: res.data, loading: false });
  //     })
  //     .catch((error) => {
  //       // console.log(error);
  //       this.setState({ loading: false });
  //     })
  // };

  handleError(error) {
    this.setState({ loading: false })
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = _model => {
    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })
    // console.log(this.state.model);
    unitTasksService
      .cancelTask(this.state.model.unitTask.id)
      .then(res => {
        toastr.success('سفارش [' + this.state.model.taskCode + '] لغو شد')
        this.table.fireFetchData()
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  importFromExcel = values => {
    this.setState({ loading: true })

    values.splice(0, 1)
    var dto = []

    values.forEach(product => {
      var obj = {}

      if (product[0] && product[2]) {
        obj['extraCode'] = parseInt(product[0], 0)
        obj['quantity'] = parseInt(product[2], 0)

        dto.push(obj)
      }
    })

    // console.log(JSON.stringify(dto));

    unitTasksService
      .importFromExcel(JSON.stringify(dto))
      .then(res => {
        var updatedCount = res.data
        toastr.success('موجودی ' + updatedCount + ' کالا بروزرسانی شد')
        this.table.fireFetchData()
      })
      .catch(error => {
        // console.log(error);
        this.setState({ loading: false })
      })
  }

  handleShowReportModal = taskId => {
    this.setState({ taskId: taskId }, () => {
      this.setState({ reportModalShow: true })
    })
  }

  handleUnitTaskStatusChange = id => {
    // console.log(id);
    let dto = this.state.dto
    dto['unitTaskStatus'] = id
    this.setState(
      {
        unitTaskStatus: id,
        dto: dto,
        resetPage: true
      },
      () => {
        // this.getData()
        this.table.fireFetchData()
      }
    )
  }

  render() {
    const {
      pageSize,
      data,
      pages,
      loading,
      searchModal,
      unitTaskStatus,
      newReserve,
      dto
    } = this.state
    return (
      <div>
        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            manual
            data={data}
            pages={pages}
            loading={loading}
            onFetchData={this.fetchData}
            ref={instance => {
              this.table = instance
            }}
            sorted={this.state.sorted}
            onSortedChange={(newSort, column) => {
              this.setState({ sorted: newSort })
            }}
            onPageSizeChange={pageSize => {
              // const { dispatch } = this.props;
              // dispatch( setPageSize(pageSize) )
              localStorage.setItem('pageSizeForProjects', pageSize)
              // this.setState({ page: 0 });
            }}
            page={this.state.page}
            onPageChange={page => this.setState({ page })}
            defaultPageSize={pageSize}
            previousText="صفحه قبل"
            nextText="صفحه بعد"
            loadingText="در حال بارگذاری ..."
            noDataText="نتیجه ای یافت نشد"
            pageText="صفحه"
            ofText="از"
            rowsText="تعداد نمایش"
            // renderPageSizeOptions = ({ pageSize, pageSizeOptions, rowsSelectorText, onPageSizeChange, rowsText }) => { return (<select onChange={e => onPageSizeChange(Number(e.target.value))} value={pageSize} > {pageSizeOptions.map((option, i) => ( // eslint-disable-next-line react/no-array-index-key <option key={i} value={option}> {${option} ${{this.props.rowsText}}} </option> ))} </select>) }

            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value
            }
            getTableProps={() => ({ style: { display: 'block' } })}
            getTrProps={(state, rowInfo, column, instance) => {
              const newSelected = Object.assign({}, this.state.selected)
              const selected = rowInfo
                ? newSelected[rowInfo.original.id]
                : false
              return {
                style: {
                  backgroundColor: selected && '#5079F7',
                  color: selected && 'white'
                }
              }
            }}
            columns={[
              {
                Header: 'ردیف',
                id: 'createdAt',
                maxWidth: 50,
                filterable: false,
                sortable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                Cell: row => {
                  return row.page * row.pageSize + (row.index + 1)
                }
              },
              {
                Header: 'کد رزرو',
                accessor: 'taskCode',
                id: 'taskCode',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['product.name'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ filter, onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: row => {
                  return (
                    <TaskCode code={row.original.taskCode} reserve={true} />
                  )
                }
              },
              // {
              //   Header: 'وضعیت',
              //   accessor: 'unitTaskStatus',
              //   id: 'unitTaskStatus',
              //   style: {
              //     display: 'flex',
              //     alignItems: 'center',
              //     overflow: 'visible',
              //     justifyContent: 'center'
              //   },
              //   sortable: false,
              //   Cell: row =>
              //     unitTaskStatuses.find(
              //       el => el.value === row.original.unitTaskStatus
              //     )
              //       ? unitTaskStatuses.find(
              //           el => el.value === row.original.unitTaskStatus
              //         ).label
              //       : ''
              // },
              // {
              //   Header: 'دسته بندی',
              //   accessor: 'product.category.name',
              //   id: 'categoryId',
              //   style: {
              //     display: 'flex',
              //     alignItems: 'center',
              //     overflow: 'visible',
              //     justifyContent: 'center'
              //   },
              //   sortable: false,
              //   Cell: row =>
              //     row.original.product &&
              //     row.original.product.category &&
              //     row.original.product.category.name
              // },
              {
                Header: 'برند',
                accessor: 'brand',
                id: 'brandId',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                sortable: false,
                Cell: row =>
                  row.original.product &&
                  row.original.product.brand &&
                  row.original.product.brand.name
              },
              {
                Header: 'نام کالا',
                accessor: 'product.name',
                id: 'name',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                sortable: false,
                Cell: row => {
                  return (
                    row.original.product &&
                    row.original.product.category &&
                    row.original.product.category.name +
                      ' (' +
                      row.original.product.name +
                      ')'
                  )
                }
              },
              // {
              //   Header: 'کد کالا',
              //   accessor: 'product.extraCode',
              //   id: 'extraCode',
              //   style: {
              //     display: 'flex',
              //     alignItems: 'center',
              //     overflow: 'visible',
              //     justifyContent: 'center'
              //   },
              //   sortable: false,
              //   Cell: row => {
              //     return row.original.product && row.original.product.extraCode
              //   }
              // },
              // {
              //   Header: 'میزان سفارش',
              //   id: 'quantity',
              //   accessor: d => d.quantity,
              //   style: {
              //     display: 'flex',
              //     alignItems: 'center',
              //     justifyContent: 'center'
              //   },
              //   className: 'text-center',
              //   sortable: false,
              //   Cell: row =>
              //     // row.original.taskType
              //     //   ?

              //     row.original.product && (
              //       <MeasurementTypeDoubleBox
              //         product={row.original.product}
              //         value={row.original.quantity}
              //         onlySub={
              //           row.original.product.subMeasurementType !== undefined
              //             ? true
              //             : false
              //         }
              //       />
              //     )

              //   //  <div className="flex-col flex-center">
              //   //   <span style={{ marginBottom: 10 }}>
              //   //     {(row.original.quantity + (row.original.product.measurementType !== undefined
              //   //       ? ' (' + measurementTypes.filter(el => el.value === row.original.product.measurementType)[0].label + ')'
              //   //       : ''))}
              //   //   </span>
              //   //   <span>
              //   //     {(Number((row.original.quantity / row.original.product.conversionUnit).toFixed(3)) + (row.original.product.subMeasurementType !== undefined
              //   //       ? ' (' + measurementTypes.filter(el => el.value === row.original.product.subMeasurementType)[0].label + ')'
              //   //       : ''))}
              //   //   </span>
              //   // </div>
              //   // : (row.original.quantity + (row.original.product.measurementType !== undefined
              //   //   ? ' (' + measurementTypes.filter(el => el.value === row.original.product.measurementType)[0].label + ')'
              //   //   : ''))
              // },
              {
                Header: 'آخرین تغییرات',
                accessor: 'updatedAt',
                id: 'updatedAt',
                filterable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: row =>
                  moment(row.original.updatedAt, 'YYYY/M/D H:m').format(
                    'jYYYY/jM/jD ساعت H:mm'
                  )
              },

              {
                Header: 'مواد اولیه رزرو شده',
                accessor: 'product.category.name',
                id: 'categoryId',
                style: {
                  display: 'block',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center',
                  minWidth: 350
                },
                width: 350,
                sortable: false,
                Cell: row =>
                  row.original.taskOperationProducts &&
                  row.original.taskOperationProducts.length > 0 ? (
                    <table className="table table-bordered m-0">
                      <thead>
                        <tr>
                          <th className="text-center">نام کالای رزرو شده</th>
                          <th className="text-center">میزان رزرو</th>
                        </tr>
                      </thead>
                      <tbody>
                        {row.original.taskOperationProducts.map(
                          (rItem, rIndex) => (
                            <tr key={rItem.id + '-' + rIndex}>
                              <td>
                                {row.original.product &&
                                  rItem.product.category && (
                                    <div className="flex flex-col">
                                      <strong>
                                        {rItem.product.category.name}
                                      </strong>
                                      <strong style={{ padding: '4px 0' }}>
                                        {rItem.product.brand.name}
                                      </strong>
                                      <strong
                                        style={{ backgroundColor: 'yellow' }}>
                                        {' (' + rItem.product.name + ')'}
                                      </strong>
                                    </div>
                                  )}
                              </td>
                              <td>
                                {rItem.product !== undefined && (
                                  <div className="flex-col flex-center">
                                    <MeasurementTypeDoubleBox
                                      product={rItem.product}
                                      value={rItem.quantity}
                                      onlySub={
                                        rItem.subquantity !== undefined &&
                                        rItem.quantity !== rItem.subQuantity
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                )}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  ) : (
                    ''
                  )
              },

              {
                Header: 'تاریخ لغو',
                accessor: 'updatedAt',
                id: 'updatedAt',
                filterable: false,
                show: unitTaskStatus === 5 ? true : false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: row =>
                  moment(row.original.updatedAt, 'YYYY/M/D H:m').format(
                    'jYYYY/jM/jD ساعت H:mm'
                  )
              },
              {
                Header: 'جزئیات',
                accessor: 'id',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                sortable: false,
                width: 100,
                // Filter: ({ filter, onChange }) =>
                //   <div className="btns-group">
                //     <a onClick={this.handleModalOperation} className="btn btn-primary react-table-add-btn" >
                //       <span>
                //         <FaPlus size="16px" />
                //         افزودن کالای جدید
                //     </span>
                //     </a>
                //     {/* <ImportExcel onChange={(val) => this.importFromExcel(val)} /> */}
                //   </div>
                // ,
                Cell: row => (
                  <div>
                    {/* <a onClick={() => this.handleModalEdit(row.index)} data-index={row.index} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn" rel="tooltip" data-original-title="ویرایش"><FiEdit size="24px" /></a> */}
                    <a
                      onClick={() =>
                        this.handleShowReportModal(row.original.unitTask.taskId)
                      }
                      className="btn btn-sm btn-simple btn-info bmd-ripple bmd-flat-btn delete-btn">
                      <FaInfoCircle size="24px" />
                    </a>
                  </div>
                )
              },
              // {
              //   Header: 'آخرین وضعیت',
              //   accessor: 'unitTask',
              //   id: 'unitTask',
              //   sortable: false,
              //   style: {
              //     display: 'flex',
              //     alignItems: 'center',
              //     overflow: 'visible',
              //     justifyContent: 'center'
              //   },
              //   show: unitTaskStatus && unitTaskStatus !== 5 ? true : false,
              //   Cell: row => (
              //     <a
              //       className="flex-col flex-center"
              //       onClick={() =>
              //         this.handleShowReportModal(row.original.unitTask.taskId)
              //       }>
              //       <span style={{ marginBottom: 10 }}>
              //         {row.original.unitTask &&
              //           row.original.unitTask.taskOperation &&
              //           taskOperationTypes.filter(
              //             el =>
              //               el.value ===
              //               row.original.unitTask.taskOperation
              //                 .taskOperationType
              //           )[0].label}
              //       </span>
              //       <span>
              //         {row.original.unitTask &&
              //           row.original.unitTask.unit &&
              //           ' (' + row.original.unitTask.unit.name + ')'}
              //       </span>
              //     </a>
              //   )
              // },
              // {
              //   Header: 'مشاهده و ویرایش',
              //   accessor: 'id',
              //   style: {
              //     display: 'flex',
              //     alignItems: 'center',
              //     justifyContent: 'center'
              //   },
              //   sortable: false,
              //   filterable: false,
              //   show: unitTaskStatus ? false : true,
              //   Cell: row => (
              //     <div>
              //       <a
              //         className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn"
              //         onClick={() => this.handleModalEdit(row.original)}>
              //         {/* <OperationIcon size="24px" color="#0063d1" className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn" /> */}
              //         <FiEdit size="24px" />
              //       </a>
              //       {/* <a onClick={() => this.handleDelete(row.index)}data-original-title="حذف" rel="tooltip"><FiTrash2 size="24px" /></a> */}
              //     </div>
              //   )
              // },
              {
                Header: 'لغو رزرو',
                accessor: 'id',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                sortable: false,
                filterable: false,
                show: dto.unitTaskStatus === -1 ? true : false,
                Cell: row => (
                  <div>
                    <a
                      className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn"
                      onClick={() => this.handleDelete(row.original)}>
                      {/* <OperationIcon size="24px" color="#0063d1" className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn" /> */}
                      <MdBlock size="24px" />
                    </a>
                    {/* <a onClick={() => this.handleDelete(row.index)}data-original-title="حذف" rel="tooltip"><FiTrash2 size="24px" /></a> */}
                  </div>
                )
              }
            ]}
            className="-striped -highlight">
            {(state, makeTable, instance) => {
              let recordsInfoText = ''

              const {
                filtered,
                pageRows,
                pageSize,
                sortedData,
                page,
                data
              } = state

              if (sortedData && sortedData.length > 0) {
                let isFiltered = filtered.length > 0

                let totalRecords = sortedData.length

                let totalDataCount = data.length

                let recordsCountFrom = page * pageSize + 1

                let recordsCountTo = recordsCountFrom + pageRows.length - 1

                if (isFiltered)
                  recordsInfoText = `${totalRecords} از ${totalDataCount} نتیجه فیلتر شده`
                else recordsInfoText = `تعداد کل: ${totalRecords}`
              } else recordsInfoText = 'نتیجه ای یافت نشد'

              return (
                <>
                  <div className="row text-right">
                    <div className="col-sm-12">
                      <span className="records-info">{`تعداد کل: ${
                        this.state.totalRecords
                      }`}</span>
                    </div>
                    <div className="col-sm-12">
                      <div className="react-table-top-area">
                        <UnitTaskStatusSelectBtns
                          defaultValue={dto.unitTaskStatus}
                          onChange={val =>
                            !loading && this.handleUnitTaskStatusChange(val)
                          }
                          exceptions={[0, 1, 2, 3, 4, 5, 10]}
                        />
                        {/* <div>
                          {' '}
                          <span className="records-info">{`تعداد کل: ${
                            this.state.totalRecords
                          }`}</span>
                        </div> */}

                        {/* <ImportExcel onChange={(val) => this.importFromExcel(val)} /> */}

                        <div>
                          <a
                            onClick={() => this.handleShowAll()}
                            className="btn btn-primary pull-left btn-sm"
                            disabled={loading}
                            style={{ margin: 0, marginLeft: 5 }}>
                            <MdPlaylistAddCheck
                              size="20px"
                              style={{ verticalAlign: 'middle' }}
                            />
                            &nbsp;نمایش همه
                          </a>

                          <a
                            onClick={() =>
                              this.setState({
                                modalHeading: 'جستجو',
                                searchModal: true
                              })
                            }
                            className="btn btn-sm btn-primary pull-left"
                            style={{ margin: 0, marginLeft: 5 }}
                            disabled={loading}>
                            <GiMagnifyingGlass
                              size="20px"
                              style={{ verticalAlign: 'middle' }}
                            />
                            &nbsp;جستجو
                          </a>

                          {this.props.user &&
                            (this.props.user.userType === 1 ||
                              this.props.user.userType === 3) && (
                              <a
                                onClick={() => this.handleModalReserve(1)}
                                className="btn btn-sm btn-info pull-left"
                                disabled={loading}
                                style={{ margin: 0, marginLeft: 5 }}>
                                <MdAdd
                                  size="20px"
                                  style={{ verticalAlign: 'middle' }}
                                />
                                &nbsp;رزرو فرآیند تولید محصول
                              </a>
                            )}

                          {/* {this.props.user && this.props.user.userType === 1 && (
                            <a
                              onClick={() => this.handleModalCreate(1)}
                              className="btn btn-sm btn-primary pull-left"
                              disabled={loading}
                              style={{ margin: 0, marginLeft: 5 }}>
                              <MdAdd
                                size="20px"
                                style={{ verticalAlign: 'middle' }}
                              />
                              &nbsp;افزودن فرآیند تولید محصول
                            </a>
                          )}

                          {this.props.user && this.props.user.userType === 1 && (
                            <a
                              onClick={() => this.handleModalCreate(0)}
                              className="btn btn-sm btn-primary pull-left"
                              disabled={loading}
                              style={{ margin: 0, marginLeft: 5 }}>
                              <MdAdd
                                size="20px"
                                style={{ verticalAlign: 'middle' }}
                              />
                              &nbsp;افزودن فرآیند تولید ورق آغشته
                            </a>
                          )} */}
                        </div>
                      </div>
                    </div>
                    <div className="clearfix" />
                    <br />
                  </div>
                  {makeTable()}
                </>
              )
            }}
          </ReactTable>
        </div>

        <Dialog
          open={searchModal && !loading}
          TransitionComponent={Transition}
          fullWidth={true}
          maxWidth="xs"
          onClose={() => this.setState({ searchModal: false })}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          // style={{ overflow: 'visible' }}
        >
          <DialogTitle>
            <Fab
              color="secondary"
              aria-label="refresh"
              size="small"
              onClick={() => this.setState({ searchModal: false })}
              className="modal-close-btn">
              <MdClose
                size="20px"
                className={loading ? 'mdi-spin mdi-loading' : ''}
              />
            </Fab>
          </DialogTitle>
          <DialogContent className="search-modal">
            {loading && <Loading />}

            <Formik
              enableReinitialize
              initialValues={this.state.dto}
              onSubmit={(values, { setSubmitting }) => {
                // // console.log(values);
                this.handleSearch(values)
                setSubmitting(false)
              }}
              // validationSchema={ValidationSchema}
            >
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                  resetForm
                } = props
                return (
                  <div className="row" style={{ position: 'relative' }}>
                    <div className="col-md-12">
                      <form onSubmit={handleSubmit}>
                        {/* {JSON.stringify(values)} */}

                        <div className="row">
                          <div className="form-inline search-container">
                            <div className="col-lg-12 col-sm-12">
                              <label>دسته بندی</label>
                              <AsyncCategorySelect
                                clearable
                                categoryType={this.props.categoryType}
                                defaultValue={values.categoryId}
                                onChange={val => {
                                  setFieldValue(
                                    'categoryId',
                                    val ? val : undefined
                                  )
                                }}
                                className="semantic-select-box"
                              />
                            </div>

                            <div className="col-lg-12 col-sm-12">
                              <label>برند</label>
                              <AsyncBrandSelect
                                clearable
                                brandType={
                                  this.props.categoryType === 0 ? 0 : 1
                                }
                                defaultValue={values.brandId}
                                onChange={val => {
                                  setFieldValue(
                                    'brandId',
                                    val ? val : undefined
                                  )
                                }}
                                className="semantic-select-box"
                              />
                            </div>

                            <div className="col-lg-12 col-sm-12">
                              <label>نام کالا</label>

                              <input
                                type="text"
                                onChange={e => {
                                  setFieldValue('name', e.target.value)
                                }}
                                value={values && values.name ? values.name : ''}
                                name="name"
                                className="text-input"
                              />
                            </div>

                            <div className="col-lg-12 col-sm-12">
                              <label>کد کالا</label>

                              <input
                                type="text"
                                onChange={e => {
                                  setFieldValue(
                                    'extraCode',
                                    parseInt(e.target.value, 0)
                                  )
                                }}
                                value={
                                  values && values.extraCode
                                    ? values.extraCode
                                    : ''
                                }
                                name="extraCode"
                                className="text-input"
                              />
                            </div>

                            <div className="col-lg-6 col-sm-12">
                              <label>کد سفارش</label>

                              <DecimalInput
                                type="tel"
                                value={
                                  values && values.taskCode
                                    ? values.taskCode
                                    : undefined
                                }
                                onChange={e => {
                                  setFieldValue('taskCode', e.target.value)
                                }}
                                className="text-input"
                              />
                            </div>

                            <div className="col-lg-6 col-sm-12">
                              <label>تاریخ سفارش</label>

                              <DatePicker
                                onChange={e => {
                                  setFieldValue('date', e)
                                }}
                                value={values && values.date ? values.date : ''}
                                name="date"
                                className="text-input"
                              />
                            </div>

                            <div className="clearfix form-row" />

                            <div className="col-md-12">
                              <button
                                type="submit"
                                className="btn btn-primary btn-block"
                                disabled={isSubmitting}>
                                {loading ? (
                                  <i className="mdi mdi-spin mdi-loading" />
                                ) : (
                                  <i className="mdi mdi-magnify" />
                                )}
                                &nbsp; جستجو &nbsp;
                              </button>
                              {/* <a className="btn btn-primary" 
                    onClick={() => {
                      setFieldValue('travelBrandId', undefined);
                      resetForm({
                        travelBrandId: undefined, transporterId: '', khodroId: '',
                        cityId: '', originTerminalId: '', destinationCityId: '', destinationTerminalId: '', tripClass: '', price: ''
                      })
                      // console.log(values);

                    }}
                  >
                    <i className="mdi mdi-playlist-check"></i>&nbsp;حذف همه فیلترها
                  </a> */}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )
              }}
            </Formik>
          </DialogContent>
        </Dialog>

        <Dialog
          open={this.state.modal}
          onClose={this.handleModalHide}
          TransitionComponent={Transition}
          scroll={'paper'}
          fullScreen={true}
          // maxWidth="lg"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description">
          <DialogTitle>
            <Fab
              color="secondary"
              aria-label="refresh"
              size="small"
              onClick={() => this.handleModalHide()}
              className="modal-close-btn">
              <MdClose size="20px" />
            </Fab>
            <span style={{ marginRight: 10 }} />
          </DialogTitle>
          <DialogContent dividers={true} style={{ minHeight: 225 }}>
            <Form
              onSubmit={() => this.handleModalClose()}
              id={this.state.model.id}
              taskType={this.state.taskType}
              categoryType={this.props.categoryType}
              onClose={() => this.handleModalClose()}
              isModal={true}
              newReserve={newReserve}
            />
          </DialogContent>
        </Dialog>

        <TaskReportModal
          taskId={this.state.taskId}
          show={this.state.reportModalShow}
          onClose={() => this.setState({ reportModalShow: false })}
        />

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={
            'آیا از لغو رزرو  [' + this.state.model.taskCode + '] مطمئن هستید؟'
          }
          text=""
          type="warning"
        />

        {loading ? <Loading /> : ''}
      </div>
    )
  }
}

// class ReserveTasks extends Component {
//   constructor(props, context) {
//     super(props, context)

//     this.state = {
//       activeTab: 'tasks'
//     }
//   }
//   render() {
//     const { activeTab } = this.state
//     return (
//       <Tabs
//         transition={false}
//         id="controlled-tab-example"
//         activeKey={activeTab}
//         onSelect={activeTab => this.setState({ activeTab })}>
//         <Tab eventKey="tasks" taskStatus={0} title="سفارشات جدید">
//           {activeTab === 'tasks' ? (
//             <DataTable
//               unitTaskStatus={0}
//               categoryType={1}
//               user={this.props.user}
//             />
//           ) : (
//             ''
//           )}
//         </Tab>
//         <Tab eventKey="assignedTasks" taskStatus={1} title="ارجاع شده">
//           {activeTab === 'assignedTasks' ? (
//             <DataTable unitTaskStatus={1} categoryType={1} />
//           ) : (
//             ''
//           )}
//         </Tab>
//         <Tab eventKey="inProgressTasks" taskStatus={2} title="در حال انجام">
//           {activeTab === 'inProgressTasks' ? (
//             <DataTable unitTaskStatus={2} categoryType={1} />
//           ) : (
//             ''
//           )}
//         </Tab>
//         <Tab
//           eventKey="materialReplacementRequest"
//           taskStatus={10}
//           title="درخواست تغییر مواد اولیه">
//           {activeTab === 'materialReplacementRequest' ? (
//             <DataTable unitTaskStatus={10} categoryType={1} />
//           ) : (
//             ''
//           )}
//         </Tab>
//         <Tab eventKey="completedTasks" taskStatus={3} title="تکمیل شده">
//           {activeTab === 'completedTasks' ? (
//             <DataTable unitTaskStatus={3} categoryType={1} />
//           ) : (
//             ''
//           )}
//         </Tab>
//         <Tab eventKey="canceledTasks" taskStatus={5} title="لغو شده">
//           {activeTab === 'canceledTasks' ? (
//             <DataTable unitTaskStatus={5} categoryType={1} />
//           ) : (
//             ''
//           )}
//         </Tab>
//       </Tabs>
//     )
//   }
// }

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}
const connectedReserveTasks = connect(mapStateToProps)(ReserveTasks)
export { connectedReserveTasks as ReserveTasks }
